import { billingStateOf } from "@/components/ShowcaseBilling";

export const hostLabelOf = (url) =>
  String(url || "")
    .trim()
    .replace(/^https?:\/\//i, "")
    .replace(/^www\./i, "")
    .replace(/\/.*$/, "");

export const websiteStatusOf = (showcase, website) => {
  const host = hostLabelOf(website);
  const state = billingStateOf(showcase);
  const live = showcase?.checklist?.live;
  const liveHost = (showcase?.sites || []).find((site) => site.lastSeenAt)?.host;
  if (state === "loading") return { line: "Loading…", action: "Open", done: null };
  if (state === "active" || state === "comped" || state === "grace") {
    if (live) return { line: `Live on ${hostLabelOf(liveHost) || host || "your website"}`, action: "Manage", done: true };
    return { line: `Subscribed. Add the code to ${host || "your website"} to go live`, action: "Finish setup", done: false };
  }
  return {
    line: host ? `Show your Buyer Want‑Listings on ${host}` : "Show your Buyer Want‑Listings on your own website",
    action: "Preview",
    done: null,
  };
};
